export default __webpack_public_path__ + "static/Wiki_Tiles_P-IN-9008HD_white-b40ee57638977e52a0add017a937fa0d.webp";